import React from 'react';
import SelectFilter from 'components/Select/SelectFilter';

const Select = (props) => (
  <SelectFilter
    dropdownProps={{
      colorIcon: '#2b3d54'
    }}
    minWidth="80px"
    containerStyles={`.label{color:${
      props.colorLabel ? props.colorLabel : '#2b3d54'
    };${
      props.fontSize && 'margin-bottom:' + Number(props.fontSize - 20) + 'px'
    }`}
    customStyles={{
      container: {
        marginTop: 5,
        height: 25,
        minHeight: 25
      },
      control: {
        border: 0,
        borderBottom: '1px solid rgba(134,142,150,0.3)',
        backgroundColor: 'transparent',
        height: '25px',
        minHeight: '25px',
        fontFamily: 'Oswald'
      },
      valueContainer: {
        height: 25,
        paddingLeft: 0,
        marginLeft: 0,
        color: '#e25c32'
      },
      singleValue: {
        color: '#e25c32',
        fontFamily: 'Oswald',
        fontSize: props.fontSize ? props.fontSize : '14px'
      },
      placeholder: {
        fontStyle: 'normal',
        color: 'white',
        opacity: 0.8
      },
      option: {
        backgroundColor: '#1a1f24',
        color: 'white',
        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.60)' },
        fontFamily: 'Oswald'
      },
      menuList: {
        backgroundColor: 'rgba(0, 0, 0, 0.53)',
        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.53)' }
      }
    }}
    {...props}
  />
);

export default Select;
